Mobi2Go.onReady(function() {
    if (Mobi2Go.headoffice.facebook_sign_in_enabled) {
        (function(d, s, id) {
            var js,
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = `https://connect.facebook.net/en_US/sdk.js#xfbml=0&version=v10.0&appId=${Mobi2Go.headoffice.facebook_app_id}&cookie=1`;
            fjs.parentNode.insertBefore(js, fjs);
        })(document, 'script', 'facebook-jssdk');
    }

    if (Mobi2Go.headoffice.apple_sign_in_enabled) {
        Mobi2Go.helpers.loadScripts(
            [
                'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js',
            ],
            true,
            () => {
                AppleID.auth.init({
                    clientId: Mobi2Go.headoffice.apple_client_id,
                    scope: 'name email',
                    redirectURI: `https://${window.location.host}`,
                    state: 'Authenticationrequest',
                    usePopup: true,
                });
            }
        );
    }
});
